import { PropsWithChildren } from 'react';
import { twJoin } from 'tailwind-merge';
import { Para, Stack } from 'ui-components';

type Props = PropsWithChildren<{
  index: number;
  disabled?: boolean;
}>;

export default function StepIndicator({ children, index, disabled = false }: Props): JSX.Element {
  const className = twJoin(
    'flex items-center justify-center text-white w-8 h-8 transition-all duration-500',
    disabled ? 'bg-gray-300' : 'bg-primary-600',
  );

  return (
    <Stack direction="row" gap={2}>
      <Para weight="bold" className={className}>
        {index}
      </Para>

      <Para className={disabled ? 'text-gray-400' : 'text-primary-600 font-semibold'}>
        {children}
      </Para>
    </Stack>
  );
}
